import React from 'react';
import { Props } from './model';
import './style.scss';
import CrossIcon from '../../assets/icons/close.svg';
export function Badges(props: Props) {
  return props.items.length === 0 ? null : (
    <div className='badges-w'>
      {props.items.map((eachItem, index) => {
        return (
          <div
            key={eachItem.name + '' + index}
            title={eachItem.title}
            style={props.title === 'Default' ? { padding: '4px 8px 4px 8px' } : {}}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <span style={{ fontSize: '14px' }}>{eachItem.name}</span>
              {props.title !== 'Default' && (
                <img
                  src={CrossIcon}
                  alt='remove'
                  style={{ width: '16px', height: '16px', marginLeft: '2px' }}
                  onClick={() => {
                    props.removeSelectedNodes(eachItem.id);
                  }}
                />
              )}
            </div>
            {props.isMutable ? (
              <div
                className='clickable remove'
                onClick={() => props.onRemove && props.onRemove(index)}>
                &times;
              </div>
            ) : null}
          </div>
        );
      })}
    </div>
  );
}
